export const HANDLE_SELECTHOME_FORM = 'HANDLE_SELECTHOME_FORM';
export const SET_CURRENT_SERVICE = 'SET_CURRENT_SERVICE';
export const SET_MODIFIED_SERVICE_OBJECT = 'SET_MODIFIED_SERVICE_OBJECT';
export const SET_REDIRECTION_INDICATOR = 'SET_REDIRECTION_INDICATOR';
export const ADDRESS_VALID_FOR_HISOPADO = "ADDRESS_VALID_FOR_HISOPADO"; 
export const SET_ADDRESS_LAT_LONG_HISOPADO = "SET_ADDRESS_LAT_LONG_HISOPADO";